import { useDispatch } from 'react-redux';
import { hideBackdrop, showBackdrop } from 'stores/sensor/sensorStore';

export function useDispatchWithBackdrop() {
  const dispatch = useDispatch();

  const dispatchWithBackdrop = async action => {
    dispatch(showBackdrop());
    try {
      const timer = new Promise(resolve => setTimeout(resolve, 500));
      const dispatchPromise = dispatch(action);
      await Promise.all([timer, dispatchPromise]);
    } finally {
      dispatch(hideBackdrop());
    }
  };

  return { dispatchWithBackdrop };
}
